module.exports = __webpack_public_path__ + "fonts/Aller_LtIt.8ec0b703.ttf";